<div #sidebar sideBar
    class="d-flex flex-column flex-shrink-0 p-3 text-white bg-dark min-vh-100 position-fixed sidebar-container"
    style="top: 0;">
    <a href="/" class="d-block p-3 link-dark text-decoration-none d-flex justify-content-center ">
        <ng-container *ngIf="logo; else defqaultLogo">
            <!-- <img [src]="logo" alt="Logo" width="32" height="32"> -->
        </ng-container>
        <ng-template #defqaultLogo>
            <img src="../../../assets/logo.png" width="32" height="32" />
        </ng-template>
        <!-- <span class="fs-4">Sidebar</span> -->
    </a>
    <hr>
    <ul class="nav nav-pills nav-flush flex-column mb-auto">
        <ng-container *ngFor="let item of menu">
            <li class="nav-item">
                <a (click)="redirectTo(item);" class="nav-link py-3 text-white"
                    [ngClass]="{'active': activeRoute == item.path}" aria-current="page">
                    <i [class]="item.icon" width="40" height="32"></i>
                    <span class="nav-label">{{item.name}}</span>
                </a>
            </li>
        </ng-container>
    </ul>
    <hr>
    <div class="dropdown">
        <a [ngbTooltip]="'Profile'"
            class="d-flex align-items-center text-white text-decoration-none justify-content-center" id="dropdownUser1"
            data-bs-toggle="dropdown" aria-expanded="false" (click)="isProfileMenuOpen = !isProfileMenuOpen">
            <i width="32" height="32" class="fa fa-user rounded-circle me-2"></i>
            <strong class="nav-label">{{userName}}</strong>
        </a>
        <ul class="dropdown-menu dropdown-menu-dark text-small shadow" [ngClass]="{
            'show': isProfileMenuOpen
        }" style="position: absolute; inset: auto auto 0px 0px; margin: 0px; transform: translate3d(0px, -34px, 0px);"
            aria-labelledby="dropdownUser1">
            <!-- <li><a class="dropdown-item">Settings</a></li> -->
            <li><a class="dropdown-item" routerLink="/profile" >Profile</a></li>
            <li>
                <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" (click)="logOut()">Sign out</a></li>
        </ul>
    </div>
</div>